import { render, staticRenderFns } from "./PointsRecord.vue?vue&type=template&id=260a6076&scoped=true&"
import script from "./PointsRecord.vue?vue&type=script&lang=js&"
export * from "./PointsRecord.vue?vue&type=script&lang=js&"
import style0 from "./PointsRecord.vue?vue&type=style&index=0&id=260a6076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a6076",
  null
  
)

export default component.exports